const { get } = require("lodash");

const getIpAddress = req =>
  get(req, "headers.x-forwarded-for", "")
    .split(",")
    .pop() ||
  get(req, "connection.remoteAddress", null) ||
  get(req, "socket.remoteAddress", null) ||
  get(req, "connection.socket.remoteAddress", null);

const headers = req => get(req, "headers", {});

const originHeader = req => get(headers(req), "origin", "");

const hostHeader = req => get(headers(req), "x-forwarded-host", "");

const protocolHeader = req => get(headers(req), "x-forwarded-proto", "");

const mobileHeader = req => get(headers(req), "x-is-mobile", null);

const authorizationHeader = req => get(headers(req), "authorization", "");

const requestBody = req => get(req, "body", {});

module.exports = {
  getIpAddress,
  headers,
  originHeader,
  hostHeader,
  protocolHeader,
  mobileHeader,
  authorizationHeader,
  requestBody
};
